import { useMemo } from 'react';

const useStayLengthDisabledSettings = (
  disabledStayLength,
  stayLengthSettings,
  { ratesTags = [] }
) => {
  //TODO: It might be the case that you want to disable the filter for one or more values

  let value =
    ratesTags.length > 0
      ? ratesTags.find((element) =>
          typeof element === 'string'
            ? element === disabledStayLength
            : element.value === disabledStayLength
        )
      : null;
  const ratesTagsSettings = useMemo(() => {
    return Boolean(value)
      ? {
          stayLengthSettings: {
            ...stayLengthSettings,
            disabled: true
          }
        }
      : {};
  }, [stayLengthSettings, value]);

  const stayLengthDisabledSettings = useMemo(() => {
    return {
      ...ratesTagsSettings
    };
  }, [ratesTagsSettings]);

  return { stayLengthDisabledSettings, stayLengthInfoLabel: value ? value.label : '' };
};

export default useStayLengthDisabledSettings;
